import HttpHelpers from './helpers';

const UserApiEndpoints = {
  getUser: (data) => {
    return HttpHelpers.authenticatedAxios
      .get('user', data)
      .then((response) => response.data);
  },

  updateUser: (data, params) => {
    return HttpHelpers.authenticatedAxios
      .patch('user', data, { params })
      .then((response) => response.data);
  },

  uploadUserImage: (data) => {
    return HttpHelpers.authenticatedAxios
      .post('user/profile-image', data)
      .then((response) => response.data);
  },

  becomeHost: () => {
    return HttpHelpers.authenticatedAxios
      .post('user/become-host')
      .then((response) => response.data);
  },

  verifyPhoneNumber: (data) => {
    return HttpHelpers.authenticatedAxios
      .post('user/phone-verify', data)
      .then((response) => response.data);
  },

  resendOtp: () => {
    return HttpHelpers.authenticatedAxios
      .post('user/resend-otp')
      .then((response) => response.data);
  },

  confirmEmail: (params) => {
    return HttpHelpers.authenticatedAxios
      .get('user/confirm-email', { params })
      .then((response) => response.data);
  },

  uploadIdentificationImage: (data) => {
    return HttpHelpers.authenticatedAxios
      .post('user/identification-image', data)
      .then((response) => response.data);
  },

  getPublicProfile: (id) => {
    return HttpHelpers.unAuthenticatedAxios
      .get(`user/${id}`)
      .then((response) => response.data);
  },
  getUserReviews: (id, params) => {
    return HttpHelpers.unAuthenticatedAxios
      .get(`user/${id}/review`, { params })
      .then((response) => response.data);
  },
};

export default UserApiEndpoints;
